import type { Dispatch } from "@reduxjs/toolkit";

export const EXPAND_TOGGLE = "navState/EXPAND_TOGGLE";

interface NavState {
  expanded: boolean;
}

interface NavStateAction {
  type: string;
}

const initialState: NavState = {
  expanded: window.innerWidth > 992,
};

const navState = (state: NavState = initialState, action: NavStateAction): NavState => {
  switch (action.type) {
    case EXPAND_TOGGLE:
      return {
        ...state,
        expanded: !state.expanded,
      };

    default:
      return state;
  }
};

export default navState;

export const expandToggle = () => {
  return (dispatch: Dispatch) => {
    dispatch({
      type: EXPAND_TOGGLE,
    });
  };
};
